import { render, staticRenderFns } from "./EmbalagemProdutoModal.vue?vue&type=template&id=51862e78"
import script from "./EmbalagemProdutoModal.vue?vue&type=script&lang=js"
export * from "./EmbalagemProdutoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports